import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const medicineMedicineRoutes = [
  {
    path: "/directories/medicine-medicine",
    name: "MedicineMedicineList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "medicineMedicine" */ "./components/List"),
  },
];
